import React from "react";
import imxtools from "imxtools";
import Icon from "../../../../../../../../../../../components/CustomIcon/Icon";
import "./index.scss";
import Attribute from "../../../../../Attribute";
import { isSelectedComponent } from "../../../../../../services/isSelectedComponent";
import { handleComponentProp } from "../../../../../../services/handleComponentProperties";
import { useStore } from "react-redux";

const Card = ({
  index = 0,
  data = {},
  path = [],
  title = "",
  setIsOpen = () => {},
  setTitleForm = () => {},
  setSelectedBody = () => {},
  selectedBody = () => {},
  currentPath = [],
  readOnly = true,
}) => {
  let store = useStore();

  return (
    <div
      className={`card-container ${
        isSelectedComponent(readOnly, [...path, "body"], currentPath) &&
        index === selectedBody
          ? "selectedComponent"
          : !readOnly && "unSelectedComponent"
      }`}
      onDoubleClick={() => setIsOpen(true)}
      onClick={(e) => {
        handleComponentProp(e, null, data, path, store, "body");
        setSelectedBody(index);
      }}
    >
      <div className="image-container">
        <Icon icon={"picture_solid"} color={"#e2e2e2"} size={"85%"} />
      </div>
      <div className="card-label">
        {data?.attribute &&
          imxtools
            ?.toArray(data?.attribute ? data?.attribute : [])
            ?.map((att, index) => {
              return (
                <React.Fragment key={index}>
                  <Attribute
                    data={att}
                    path={path}
                    setTitleForm={setTitleForm}
                    index={index}
                    classification={true}
                    readOnly={readOnly}
                  />
                </React.Fragment>
              );
            })}
      </div>
    </div>
  );
};

export default Card;
